<template>
  <div class="register">
     <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"> </v-topBar>

    <v-registerTop :navTitle="navTitle"  :webConfigInfo='webConfigInfo'></v-registerTop>
    <!-- <div class="setNavBg">
      <v-header :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo' ></v-header>
    </div> -->
    <div class="registerStepTit"><h3>{{titleName}}</h3></div>
    <div class="registerStepCon">
      <el-steps :active="1" align-center>
        <el-step title="1 填写企业信息"></el-step>
        <el-step title="2 完善个人信息"></el-step>
        <el-step title="3 提交审核"></el-step>
        <el-step title="4 完成注册"></el-step>
      </el-steps>
      <div class="formCon">
          <h5 v-if="showNoticeFlag" style="color:red">请确认修改的企业信息,请点击提交。</h5>
          <h5 v-if="showNoticeFlag">个人信息显示如下：</h5>

        <el-form :model="baseRuleForm" :rules="supplierRules" ref="supplierRuleForm" label-width="160px" class="demo-ruleForm">
          <el-form-item label="姓名" prop="trueName" >
            <el-input autofocus v-model="baseRuleForm.trueName" placeholder="请输入真实姓名" ></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="mobile">
            <el-input v-model="baseRuleForm.mobile" placeholder="请输入您的常用手机号码" :disabled="diableFlag"></el-input>
            <el-checkbox v-show="!diableFlag" v-model="baseRuleForm.overseasMobile" @change="changeMobile">境外手机号</el-checkbox>
          </el-form-item>
          <el-form-item label="登录账号" prop="email">
            <el-input v-model="baseRuleForm.email"  placeholder="请输入有效邮箱" :disabled="diableFlag" autocomplete="off"></el-input>
            <span>邮箱即您的一链网登录账号，请妥善保存</span>
          </el-form-item>
          <el-form-item label="邮箱验证码" prop="emailVerfyCode" v-show="showFlag">
            <el-input v-model="baseRuleForm.emailVerfyCode" @blur="changeCode()" autocomplete="off" :disabled="diabledVerifyCodeFlag"></el-input>
            <el-button :disabled="disabledBtn" plain @click="findVerifyCode()">{{verifyBtn}}</el-button>
          </el-form-item>
          <input type="hidden">
          <el-form-item label="设置密码" prop="password" class="clearfix" v-show="showFlag">
            <el-input v-model="baseRuleForm.password" class="pull-left" @input="changePassword" placeholder="请输入6-20位的登录密码" type="password" autocomplete="new-password" ref="password" :minlength="6" :maxlength="20"></el-input>
            <div class="progress">
              <div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" :style="passwordStyle">
                <span class="sr-only">40% Complete (success)</span>
              </div>
            </div>
            <span>{{passwordLevelDescribe}}</span>
            <ul style="margin-top: 1px">
              <li>6~20个字符</li>
              <li>只能包含字母、数字以及标点符号(除空格)</li>
            </ul>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPassword" v-show="showFlag">
            <el-input v-model="baseRuleForm.confirmPassword" type="password" :minlength="6" :maxlength="20" placeholder="重新输入登录密码"></el-input>
          </el-form-item>
          <el-form-item class="btnCon">
            <el-button @click="back()">上一步</el-button>
            <el-button type="primary" :disabled="registerDisabled" @click="submitForm('supplierRuleForm')">继续</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <v-footer :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos' ></v-footer>
    <v-backToTop></v-backToTop>
  </div>
</template>
<script>
  import header from '@/components/v-header/header'
  import topBar from '@/components/topBar'
  import registerTop from '@/components/registerTop'
  import footer from '@/components/v-footer'
  import backToTop from '@/components/backToTop'
  import { mapState } from 'vuex'
  import {customPersonalInformation} from '@/assets/js/sensors'

  export default {
    props: [],
    data () {
      var checkPassword = (rule, value, callback) => {
        if (value!=this.$refs.password.value) {
          return callback(new Error('两次密码不一致'));
        }else{
          return callback();
        }
      };
      var requirePassword = (rule, value, callback) => {
        if (this.showFlag && value == '') {
          return callback(new Error('请输入密码'));
        }else{
          return callback();
        }
      };
      var requirePasswordExt = (rule, value, callback) => {
        if (this.showFlag && value == '') {
          return callback(new Error('请输入确认密码'));
        }else{
          return callback();
        }
      };
      var checkPasswordExt = (rule, value, callback) => {
        if (value.indexOf(" ")!=-1) {
          return callback(new Error('密码格式不正确，请输入6-20位的字母、数字或符号'));
        }else{
          return callback();
        }
      };
      var checkMobile = (rule, value, callback) => {
        var reg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if(this.diableFlag){
          this.baseRuleForm.overseasMobile = true;
        }
        if (!reg.test(value)&&!this.baseRuleForm.overseasMobile) {
          return callback(new Error('请输入11位有效手机号码'));
        }else if(value.length>20){
          return callback(new Error('境外手机号码长度不能超过20位'));
        }else{
          return callback();
        }
      };
      var checkEmail = (rule, value, callback) => {
        this.baseRuleForm.email = value.trim();
        var regEmail=new RegExp("^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$");
        if (!regEmail.test(this.baseRuleForm.email)) {
          return callback(new Error('邮箱格式不正确'));
        }else{
          return callback();
        }
      };
      var checkUserName = (rule, value, callback) => {
        // var regUserName=new RegExp("^[a-zA-Z\u4e00-\u9fa5]+$");
        // if (!regUserName.test(value)) {
        //   return callback(new Error('您输入的字符不规范，请重新输入'));
        // }else{
        //   return callback();
        // }
        if(value.length<1){
          return callback(new Error('您输入的字符不规范，请重新输入'));
        }else if(value.length>500){
          return callback(new Error('您输入的字符不规范，请重新输入'));
        }else{
          return callback();
        }
      };
      return {
        diabledVerifyCodeFlag:true,
        showNoticeFlag:false,
        showFlag:true,
        checkCodeFlag:false,
        regeisterSuccessInfo:{},
        sendEmailFlag:false,
        userAgreementVisible: false,
        privacyPolicyVisible: false,
        centerDialogVisible: false,
        navigationColumnInfos: [],
        footerColumnInfos: [],
        webConfigInfo: {},
        checkList:[],
        passwordStyle:'',
        navTitle:'注册',
        verifyBtn:'获取验证码',
        disabledBtn:false,
        abroadShow:false,
        baseRuleForm: {
          trueName: '',
          mobile: '',
          email: '',
          emailVerfyCode: '',
          password: '',
          confirmPassword: '',
          overseasMobile:false
        },
        requestCompanyInfo:{},
        regeisterType:'',
        passwordLevelDescribe:'低',
        supplierRules: {
          trueName: [
            { required: true, message: '请输入姓名', trigger: 'blur' },
            { min: 1, max: 500, message: '您输入得字符不规范,请重新输入', trigger: 'blur' },
            { validator: checkUserName, trigger: 'blur' }

          ],
          mobile: [
            { required: true, message: '请输入您手机号码，以免遗失您的重要信息', trigger: 'blur'},
            { validator: checkMobile, trigger: 'blur' }
          ],
          emailVerfyCode: [
            { required: true, message: '请输入邮箱验证码', trigger: 'blur'}
          ],
          email: [
            { required: true, message: '邮箱即您的一链网登录账号，请妥善保存', trigger: 'blur'},
            { validator: checkEmail, trigger: 'blur' }
          ],
          password: [
            { required: true, validator: requirePassword, trigger: 'blur'},
            { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' },
            { validator: checkPasswordExt, trigger: 'blur' }
          ],
          confirmPassword: [
            { required: true, validator: requirePasswordExt, trigger: 'blur'},
            { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' },
            { validator: checkPassword, trigger: 'blur' },
            { validator: checkPasswordExt, trigger: 'blur' }
          ]
        },
        hitSearchUrl:'',
        enterpriseResourceBaseUrl:'',
        yellowPageColumn:{},
        productAndSolutionColumn:{},
        regeisterInfo:{},
        regeisterExtInfo:{},
        selectOrgIdentity:'',
        titleName:'',
        userId:'',
        email:'',
        companyId:'',
        companyName:'',
        orgIdentity:'',
        regAddrType:'',
        userExistFlag:false,
        userExistInfo:{},
        diableFlag:false,
        companyInfoExt:{},
        userId:'',
        registerDisabled:false
      }
    },
    components: {
      'v-header': header,
      'v-topBar': topBar,
      'v-registerTop': registerTop,
      'v-footer': footer,
      'v-backToTop': backToTop
    },
    // watch:{
    //   email(val){
    //     if(val!='' && !this.sendEmailFlag){
    //       this.$message({
    //           message: '请点击"获取验证码"后，再填写邮箱验证码',
    //           type: 'error'
    //       });
    //       return false;
    //     }
    //     if(val!='' && this.baseRuleForm.emailVerfyCode!=''){
    //       this.$axios.post('/onelink.mdata.main.api/email/checkVerifyCode?email='+val+"&code="+this.baseRuleForm.emailVerfyCode+"&action=regeister_", {
    //       }).then((res) => {
    //         this.data = res.data;
    //         let operateFlag = this.data.data;
    //         if(!operateFlag){
    //           this.$message({
    //             message: '邮箱验证码输入错误',
    //             type: 'error'
    //           });
    //           this.checkCodeFlag = false;
    //         }else{
    //           this.checkCodeFlag = true;
    //         }
    //       }).catch((err) => {
    //         console.log(err)
    //       })
    //     }
    //   }
    // },
    created () {
      let query = this.$route.query;
      this.email  = query.email;
      this.companyId = query.companyId;
      this.companyName = query.companyName;
      this.orgIdentity = query.orgIdentity;
      this.regAddrType = query.regAddrType;
      this.userId = query.userId;
      this.requestCompanyInfo = JSON.parse(this.getDAesString(this.getToken('requestCompanyInfo'),this.KP.key,this.KP.iv));
      if(typeof(this.email) == "undefined"){
        this.showNoticeFlag =false;
        this.regeisterExtInfo = JSON.parse(this.getDAesString(this.getToken('regeisterInfo'),this.KP.key,this.KP.iv));
        this.regeisterExtInfo.id = this.companyId;
        this.selectOrgIdentity  = this.regeisterExtInfo.orgIdentity;
        this.showFlag = true;
      }else{
        this.requestCompanyInfo.id = this.companyId
        this.showNoticeFlag =true;
        this.selectOrgIdentity  = this.orgIdentity;
        this.showFlag = false;
      }

      if(this.selectOrgIdentity == '20'){
        this.titleName = '采购商注册';
      }
      if(this.selectOrgIdentity == '10'){
        this.titleName = '供应商注册';
      }


      this.regeisterType = this.getToken('regeisterType');
      this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainPersonInfo?email='+this.email, {
      }).then((res) => {
        this.data = res.data;
        this.webConfigInfo = this.data.webConfigInfoDto;
        this.footerColumnInfos = this.data.footerColumnInfos;
        this.navigationColumnInfos = this.data.navigationColumnInfos;
        this.yellowPageColumn = this.data.yellowPageColumn;
        this.productAndSolutionColumn = this.data.productAndSolutionColumn;
        this.hitSearchUrl = this.data.hitSearchUrl;
        this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
        this.baseRuleForm.emailVerfyCode = '';
        this.baseRuleForm.password = '';
        this.userExistFlag = this.data.userExistFlag;
        this.userExistInfo = this.data.userInfo;
        if(this.userExistFlag){
          this.baseRuleForm.trueName = this.userExistInfo.trueName;
          this.baseRuleForm.mobile = this.userExistInfo.mobile;
          this.baseRuleForm.email = this.userExistInfo.email;
          this.findVerifyCodeNoCheck();
          this.checkCodeFlag = true;
          this.diableFlag = true;
        }else{
          this.diableFlag = false;
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    mounted () {
      this.baseRuleForm.emailVerfyCode = '';
        this.baseRuleForm.password = '';
    },
    computed: mapState([
      'KP'
    ]),
    methods: {
      submitForm(formName) {
        this.$refs['supplierRuleForm'].validate((valid) => {
          if (valid) {

            if(this.showFlag){
              if(this.baseRuleForm.email!='' && !this.sendEmailFlag){
                this.$message({
                  message: '请点击"获取验证码"后，再填写邮箱验证码',
                  type: 'error'
                });
                return false;
              }

              if(!this.checkCodeFlag){
                this.$message({
                  message: '邮箱验证码输入错误',
                  type: 'error'
                });
                return false;
              }
            }


            if(this.baseRuleForm.email !='' && this.baseRuleForm.emailVerfyCode!=''){
              this.registerDisabled=true;
              this.$axios.post('/onelink.mdata.main.api/email/checkVerifyCode?email='+this.baseRuleForm.email+"&code="+this.baseRuleForm.emailVerfyCode+"&action=regeister_", {
              }).then((res) => {
                this.data = res.data;
                let operateFlag = this.data.data;
                if(!operateFlag&&this.showFlag){
                  this.registerDisabled=false;
                  this.$message({
                    message: '邮箱验证码输入错误',
                    type: 'error'
                  });
                  this.checkCodeFlag = false;
                }else{
                  this.checkCodeFlag = true;
                  if(this.regeisterType == 'user'){
                    this.$axios.post('/onelink.mdata.main.api/regeister/saveNewUsersAppInfo', {
                      id:this.userId,
                      userName:this.baseRuleForm.email,
                      trueName:this.baseRuleForm.trueName,
                      mobile:this.baseRuleForm.mobile,
                      email:this.baseRuleForm.email,
                      password:this.baseRuleForm.password,
                      requestCompanyInfo:this.requestCompanyInfo,
                      registeInviteCode: this.$route.query.registeInviteCode || ''
                    }).then((res) => {
                      this.data = res.data;
                      let operateFlag = this.data.data.operateFlag;
                      if(operateFlag){
                        this.regeisterSuccessInfo.companyId = this.data.data.oRGUserRelationsDto.orgId;
                        this.regeisterSuccessInfo.trueName = this.baseRuleForm.trueName;
                        this.regeisterSuccessInfo.email =this.baseRuleForm.email;
                        this.setToken('regeisterSuccessInfo', this.getAesString(JSON.stringify(this.regeisterSuccessInfo),this.KP.key,this.KP.iv));
                        this.setToken('regeisterType',this.regeisterType);
                        this.setToken('isLogin','');
                        this.setToken('regeisterInfo',this.getAesString(JSON.stringify(this.regeisterInfo),this.KP.key,this.KP.iv));
                        this.setToken('examineStatus',200);
                        this.$router.push({path:"/registerExamine"});
                      }else{
                        this.registerDisabled=false;
                        this.$message({
                          message: '注册失败！失败原因：'+this.data.data.errorInfo,
                          type: 'error'
                        });
                      }

                    }).catch((err) => {
                      console.log(err)
                    })
                  }

                  if(this.regeisterType == 'company'){
                    this.$axios.post('/onelink.mdata.main.api/regeister/saveNewEnterpriseUsers', {
                      id:this.userId,
                      trueName:this.baseRuleForm.trueName,
                      mobile:this.baseRuleForm.mobile,
                      email:this.baseRuleForm.email,
                      password:this.baseRuleForm.password,
                      requestCompanyInfo:this.requestCompanyInfo,
                      registeInviteCode: this.$route.query.registeInviteCode || ''
                    }).then((res) => {
                      this.data = res.data;
                      let operateFlag = this.data.data.operateFlag;
                      if(operateFlag){
                        this.regeisterSuccessInfo.companyId = this.data.data.oRGUserRelationsDto.orgId;
                        this.regeisterSuccessInfo.trueName = this.baseRuleForm.trueName;
                        this.regeisterSuccessInfo.email =this.baseRuleForm.email;
                        this.setToken('regeisterSuccessInfo', this.getAesString(JSON.stringify(this.regeisterSuccessInfo),this.KP.key,this.KP.iv));
                        this.setToken('regeisterType',this.regeisterType);
                        this.setToken('isLogin','');
                        this.setToken('regeisterInfo',this.getAesString(JSON.stringify(this.regeisterInfo),this.KP.key,this.KP.iv));
                        this.setToken('examineStatus',200);
                        this.$router.push({path:"/registerExamine"});
                      }else{
                        this.registerDisabled=false;
                        this.$message({
                          message: '注册失败！失败原因：'+this.data.data.errorInfo,
                          type: 'error'
                        });
                      }

                    }).catch((err) => {
                      console.log(err)
                    })
                  }
                }
              }).catch((err) => {
                console.log(err)
              })
            }

            // 埋点
            try {
              customPersonalInformation({
                org_id:this.$route.query.orgCode,
                org_name:this.$route.query.orgName,
                user_name:this.baseRuleForm.email,
                mobile:this.baseRuleForm.mobile
              })
            } catch (e) {
              console.log(e)
            }

          } else {
            console.log('error submit!!');
            return false;
          }
      });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      goToHref(val){
        this.$router.push({path: val})
      },
      changePassword(value){
        console.log(value)
        var modes = 0;
        //正则表达式验证符合要求的
        if (value.length < 1) return modes;
        if (/\d/.test(value)) modes++; //数字
        if (/[a-z]/.test(value)) modes++; //小写
        if (/[A-Z]/.test(value)) modes++; //大写
        if (/\W/.test(value)) modes++; //特殊字符
        //逻辑处理
        switch (modes) {
          case 1:
            this.passwordStyle="width: 20%;background:red";
            this.passwordLevelDescribe = '低';
            break;
          case 2:
            this.passwordStyle="width: 40%;background:red";
            this.passwordLevelDescribe = '低';
            break;
          case 3:
            this.passwordStyle="width: 80%;background:orange";
            this.passwordLevelDescribe = '中';
            break;
          case 4:
            this.passwordStyle="width: 100%;background:green";
            this.passwordLevelDescribe = '高';
            break;
        }
      },
      findVerifyCode(){
//        var regEmail=new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
        var regEmail=new RegExp("^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$");
        if (!regEmail.test(this.baseRuleForm.email)) {
          this.$message({
              message: '邮箱格式不正确',
              type: 'error'
          });
          return false;
        }
        if(this.baseRuleForm.email == ''){
          this.$message({
              message: '获取验证码前，请输入邮箱！',
              type: 'error'
          });
          return false;
        }else{
          this.$axios.post('/onelink.mdata.main.api/email/sendVerifyCode?email='+this.baseRuleForm.email, {
          }).then((res) => {
            this.data = res.data;
            let operateFlag = this.data.operateFlag;
            let verifyCode = this.data.verifyCode;
            if(operateFlag){
              this.$message({
                message: '发送成功',
                type: 'success'
              });
              this.sendEmailFlag = true;
              this.diabledVerifyCodeFlag = false;
              this.getVerify();
              // this.baseRuleForm.emailVerfyCode = verifyCode;
            }else{
              this.$message({
                message: this.data.errorInfo,
                type: 'error'
              });
            }
          }).catch((err) => {
            console.log(err)
          })
        }

      },
      findVerifyCodeNoCheck(){
          this.$axios.post('/onelink.mdata.main.api/email/sendVerifyCodeNoCheck?email='+this.baseRuleForm.email, {
          }).then((res) => {
            this.data = res.data;
            let operateFlag = this.data.operateFlag;
            let verifyCode = this.data.verifyCode;
            if(operateFlag){
              this.baseRuleForm.emailVerfyCode = verifyCode;
              this.sendEmailFlag = true;
              // this.baseRuleForm.emailVerfyCode = verifyCode;
            }else{
              this.sendEmailFlag = false;
            }
          }).catch((err) => {
            console.log(err)
          })
      },
//      验证码获取倒计时
      getVerify(){
        let time=90
        clearInterval(myInterval)
        let myInterval = setInterval(()=>{
          this.verifyBtn=time+"秒后重新获取";
          time--;
          if(time<0){
            clearInterval(myInterval)
            this.verifyBtn="重新获取验证码";
            this.disabledBtn=false;
          }
        }, 1000);
        this.disabledBtn=true;
      },
      changeCode(){
        if(this.baseRuleForm.email!='' && !this.sendEmailFlag){
          this.$message({
              message: '请点击"获取验证码"后，再填写邮箱验证码',
              type: 'error'
          });
          return false;
        }
        if(this.baseRuleForm.email !='' && this.baseRuleForm.emailVerfyCode!=''){
          this.$axios.post('/onelink.mdata.main.api/email/checkVerifyCode?email='+this.baseRuleForm.email+"&code="+this.baseRuleForm.emailVerfyCode+"&action=regeister_", {
          }).then((res) => {
            this.data = res.data;
            let operateFlag = this.data.data;
            if(!operateFlag){
              this.$message({
                message: '邮箱验证码输入错误',
                type: 'error'
              });
              this.checkCodeFlag = false;
            }else{
              this.checkCodeFlag = true;
            }
          }).catch((err) => {
            console.log(err)
          })
        }
      },
      back(){
        if(typeof(this.email) == "undefined"){
          this.regeisterExtInfo = JSON.parse(this.getDAesString(this.getToken('regeisterInfo'),this.KP.key,this.KP.iv));
        }else{
          this.regeisterExtInfo.companyName = this.companyName;
          this.regeisterExtInfo.orgIdentity = this.orgIdentity;
          this.regeisterExtInfo.regAddrType = this.regAddrType;
          this.regeisterExtInfo.companyId = this.companyId;
        }
        // if(this.requestCompanyInfo.regAddrType == '1'){
        //   this.regeisterExtInfo.requestCompanyInfo = this.requestCompanyInfo;
        //   this.setToken("regeisterInfo",this.getAesString(JSON.stringify(this.regeisterExtInfo),this.KP.key,this.KP.iv));
        //   this.$router.push({path:'/registerBusinessInfo'})
        // }else{
          this.$axios.post('/onelink.mdata.main.api/company/findOrgInformationByLicenceOrName?orgName='+encodeURI(this.requestCompanyInfo.orgName)+"&orgIdentity="+this.requestCompanyInfo.orgIdentity+"&licenceCode="+this.requestCompanyInfo.licenceCode+"&regAddrType="+this.requestCompanyInfo.regAddrType, {
          }).then((res) => {
            this.data = res.data;
            let operateFlag = this.data.data.checkFlag;
            this.companyInfoExt = this.data.data.companyInfo;

            if(operateFlag && this.companyInfoExt.orgStatus != '25'){
              this.companyInfo = this.data.data.companyInfo;
              this.regeisterExtInfo.requestCompanyInfo = this.requestCompanyInfo;
              this.regeisterExtInfo.companyId = this.companyInfo.id;
              this.regeisterExtInfo.requestCompanyInfo = this.requestCompanyInfo;
              // 保存一下企业审批状态
                this.regeisterExtInfo.orgStatus = this.companyInfoExt.orgStatus;
                // this.regeisterExtInfo.currentTrueName = currentTrueName;
                // this.regeisterExtInfo.currentEmail =currentEmail;
              this.setToken("regeisterInfo",this.getAesString(JSON.stringify(this.regeisterExtInfo),this.KP.key,this.KP.iv));
              if(typeof(this.email) != "undefined"){
                this.$router.push({path: '/registerExistBusinessInfo',query:{userId:this.userId,email:this.email,companyId:this.companyId,companyName:this.companyName,orgIdentity:this.orgIdentity,regAddrType:this.regAddrType,regeisterType:this.regeisterType}})
              }else{
                 this.$router.push({path:'/registerExistBusinessInfo'})
              }

            }else{
              this.regeisterExtInfo.requestCompanyInfo = this.requestCompanyInfo;
              this.setToken("regeisterInfo",this.getAesString(JSON.stringify(this.regeisterExtInfo),this.KP.key,this.KP.iv));

              if(typeof(this.email) != "undefined"){
                this.$router.push({path: '/registerBusinessInfo',query:{userId:this.userId,email:this.email,companyId:this.companyId,companyName:this.companyName,orgIdentity:this.orgIdentity,regAddrType:this.regAddrType,regeisterType:this.regeisterType}})
              }else{
                this.$router.push({path:'/registerBusinessInfo'})
              }
            }
          }).catch((err) => {
            console.log(err)
          })
        // }
      },
      changeMobile(){
        this.$refs['supplierRuleForm'].validateField('mobile', (valid) => {});
      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/registerUserInfo/index.vue